import { 
    RequestPreviewDto, 
    RequestDownloadExcelDto, 
    RequestDownloadPdfDto, 
    RequestSendEmailExcelDto, ResponseSendEmailExcelDto, 
    RequestSendEmailPdfDto, ResponseSendEmailPdfDto 
} from './../dto/career-report.dto';
import { NestApiProvider } from './../../nest-api';
import { Injectable } from "@angular/core";
import {Observable} from "rxjs";

@Injectable()
export class CareerReportApi {

    private service: string ='';
    private model: string = 'CareerReport';

    constructor(
        public nestApiProvider: NestApiProvider
    ){}

    public preview(data: RequestPreviewDto){
        const method: string = 'POST';
        const func: string = 'preview';
        const params: RequestPreviewDto = data;
        const urlParams: any = {};
        const body: any = {}

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<RequestPreviewDto>(method, url, params, urlParams, body, null);
    }

    public downloadExcel(data: RequestDownloadExcelDto){
        const method: string = 'POST';
        const func: string = 'downloadExcel';
        const params: RequestDownloadExcelDto = data;
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
    }

    public downloadPdf(data: RequestDownloadPdfDto) {
        const method: string = 'POST';
        const func: string = 'downloadPdf';
        const params: RequestDownloadPdfDto = data;
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
    }

    public reportSendEmailExcel(data: RequestSendEmailExcelDto): Observable<ResponseSendEmailExcelDto> {       
         const method: string = 'POST';
        const func: string = 'reportSendEmailExcel';
        const params: RequestSendEmailExcelDto = data;
        const urlParams: any = {};
        const body: any = {};
        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseSendEmailExcelDto>(method, url, params, urlParams, body, null);
    }

    public reportSendEmailPdf(data: RequestSendEmailPdfDto): Observable<ResponseSendEmailPdfDto> {
        const method: string = 'POST';
        const func: string = 'reportSendEmailPdf';
        const params: RequestSendEmailPdfDto = data;
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<ResponseSendEmailPdfDto>(method, url, params, urlParams, body, null);
    }

    public careerType(): Observable<any> {
        const method: string = 'GET';
        const func: string = 'careerType';
        const params: any = {};
        const urlParams: any = {};
        const body: any = {};

        const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
        return this.nestApiProvider.request<any>(method, url, params, urlParams, body, null);
    }
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/career-report.api.ts